<template>
  <div>
    <vxe-grid
      ref="xTable"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :height="tableHeight"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      size="small"
      border
      row-key
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 16px; color: #606266">{{
              $l('form_label_task_range') || '盘点范围'
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              v-if="!disabled"
              variant="outline-info"
              @click="choiceGoods()"
              >{{ $l('btn_range_add') || '新增盘点范围' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:isOverStatusInfo="{ row }">
        <el-tag
          size="mini"
          :type="
            row.isOverStatus === 'Y'
              ? 'success'
              : row.isOverStatus === 'N'
              ? 'info'
              : ''
          "
        >
          {{ row.isOverStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <choose-location-dialog
      :visible.sync="chooseDialogVisible"
      type="checkbox"
      :taskRangeFlag="taskRangeFlag"
      @confirm="addData"
    />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import ChooseLocationDialog from './choose-location/dialog.vue'
export default {
  mixins: [BaseTable],
  props: {
    data: {
      type: Object,
      default: null
    },
    taskRangeFlag: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ChooseLocationDialog
  },
  data() {
    return {
      chooseDialogVisible: false,
      tableHeight: 320,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        }
      },
      tableData: [],
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          fixed: 'right',
          visible: !this.disabled,
          slots: {
            default: 'opt'
          }
        },
        {
          title: this.$l('form_label_warehouseNo') || '库房编号',
          headerAlign: 'left',
          align: 'left',
          minWidth: '120',
          field: 'warehouseNo'
        },
        {
          title: this.$l('form_label_warehouseDescription') || '库房名称',
          headerAlign: 'left',
          align: 'left',
          minWidth: '200',
          field: 'warehouseDescription'
        },
        {
          title: this.$l('form_label_locationNo') || '库位编号',
          headerAlign: 'left',
          align: 'left',
          minWidth: '120',
          field: 'locationNo'
        },
        {
          title: this.$l('form_label_locationDescription') || '库位名称',
          headerAlign: 'left',
          align: 'left',
          minWidth: '200',
          field: 'locationDescription'
        },
        {
          title: this.$l('form_label_isOverStatusName') || '核查状态',
          headerAlign: 'center',
          align: 'center',
          minWidth: '120',
          field: 'isOverStatusName',
          slots: {
            default: 'isOverStatusInfo'
          }
        }
      ]
    }
  },
  watch: {
    data: {
      handler() {
        this.tableData = this.data.rangeList
      },
      immediate: true
    }
  },
  methods: {
    async choiceGoods() {
      if (!this.taskRangeFlag) {
        this.$message({
          showClose: true,
          message: this.$l('tips_form_label_taskRangeFlag') || '请选择任务范围',
          type: 'warning'
        })
        return
      }
      this.chooseDialogVisible = true
    },
    addData(chooseData) {
      if (!chooseData) {
        return
      }
      chooseData.forEach((item) => {
        let singleRow = {
          taskRangeCode: '',
          warehouseCode: item.warehouseCode,
          warehouseNo: item.warehouseNo,
          warehouseDescription: item.warehouseDescription,
          locationCode: item.locationCode,
          locationNo: item.locationNo,
          locationDescription: item.locationDescription,
          isOverStatus: 'N',
          isOverStatusName: 'No Check'
        }
        let findCount = 0
        this.tableData.forEach((row) => {
          if (item.locationCode === row.locationCode) {
            findCount++
          }
        })
        if (findCount === 0) {
          this.tableData.push(singleRow)
        }
      })
    },
    delRow(row) {
      let index = this.$refs.xTable.getRowIndex(row)
      this.tableData.splice(index, 1)
    },
    close() {
      this.chooseDialogVisible = false
    },
    getListData() {
      return this.tableData
    }
  }
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
